import { Component, OnInit, OnDestroy, ElementRef, HostListener, OnChanges, Input } from '@angular/core';
import * as d3 from 'd3';
import { SharedUtils } from '../../../../../../shared/shared.utils';
import { LoadingModule, ANIMATION_TYPES } from 'ngx-loading';
import { SessionStateService } from '../../../../../../core/services/session-state.service';
@Component({
  selector: 'app-microgeneration-flow',
  templateUrl: './microgeneration-flow.component.html',
  styleUrls: ['./microgeneration-flow.component.scss']
})

export class MicrogenerationFlowComponent implements OnInit, OnChanges {
  @Input()
  gridInjection;
  @Input()
  gridConsumption;
  @Input()
  consumptionSmartMeterIsOnline: boolean;
  @Input()
  injectionSmartMeterIsOnline: boolean;

  // *D3 *//
  path: any;
  svgTop: any;
  svgBottom: any;

  consumptionFlowAnimation;
  injectionFlowAnimation;

  totalProduction = null;
  totalConsumption = null;
  innerWidth: number;
  innerHeight: number;
  marginWidth: number;
  marginHeight: number;
  marker;
  upPath;
  downPath;
  lineUpstring;
  lineDownstring;
  SharedUtils = SharedUtils;

  consumptionLoadingAnimationConfig = {
    animationType: ANIMATION_TYPES.circleSwish,
    backdropBackgroundColour: 'rgba(0, 0, 0, 0)'
  }

  productionLoadingAnimationConfig = {
    animationType: ANIMATION_TYPES.circleSwish,
    primaryColour: '#287aab',
    secondaryColour: '#287aab',
    tertiaryColour: '#287aab',
    backdropBackgroundColour: 'rgba(0, 0, 0, 0)'
  }

  loadingInjection: boolean = true;
  loadingConsumption: boolean = true;

  constructor(public sessionStateService: SessionStateService) { }

  // In order to fix memory issues ==> When screen is not being shown animation should be stopped
  @HostListener('document:visibilitychange')
  onVisibilityChange() {
    if(document.hidden) {
      this.stopAnimations();
    } else {
      this.startAnimations();
    }
  }

  ngOnInit() {
    // this.loadingInjection = this.gridConsumption ? false : true;
    // this.loadingConsumption = this.gridInjection ? false : true;
    this.createLines();
    this.startAnimations();
    this.ngOnChanges();
  }

  ngOnChanges(): void {

    if(this.gridConsumption !== null) {
      this.loadingConsumption = false;
      this.totalConsumption = this.gridConsumption;
    }

    if(this.gridInjection !== null) {
      this.loadingInjection = false;
      this.totalProduction = this.gridInjection;
    }

    // Consumption Offline
    if(this.consumptionSmartMeterIsOnline === false) {
      $('#consumptionOfflineContainer').css('display', 'block');
    }

    // Injection Offline
    if(this.injectionSmartMeterIsOnline === false) {
      $('#injectionOfflineContainer').css('display', 'block');
    }
  }

  getHouseGridIcon() {
    if (this.totalProduction > 0 && this.totalConsumption > 0) {
      return '/assets/img/icons/flow_house_microgeneration.svg';
    } else if (this.totalProduction > 0 && this.totalConsumption === 0) {
      return '/assets/img/icons/flow_house_microgeneration_generate.svg';
    } else if (this.totalProduction === 0 && this.totalConsumption > 0) {
      return '/assets/img/icons/flow_house_microgeneration_consume.svg';
    } else {
      return '/assets/img/icons/flow_house_none_micro.svg';
    }
  }

  createLines() {
    this.svgTop = d3.select("#topLineChart")
      .attr('width', 650)
      .attr('height', '100%');
    
    this.svgBottom = d3.select("#anotherId")
      .attr('width', 650)
      .attr('height', '100%');

    const lineGenerator = d3.line();
    lineGenerator.curve(d3.curveBasis);
    this.lineUpstring = lineGenerator([[90, 70], [120, 10], [335, 10], [550, 10], [580, 70]]);
    this.lineDownstring = lineGenerator([[580, 10], [550, 70], [335, 70], [120, 70], [90, 10]]);

    this.upPath = this.svgTop.append('path')
      .attr('d', this.lineUpstring)
      .attr('stroke-width', '3')
      .attr('fill', '#FBFBFB')
      .attr('stroke', '#287aab');

    this.downPath = this.svgBottom.append('path')
      .attr('d', this.lineDownstring)
      .attr('stroke-width', '3')
      .attr('fill', '#FBFBFB')
      .attr('stroke', '#fb6059');
  }

  startAnimations() {
    this.consumptionFlowAnimation = setInterval(() => {
      if (this.totalProduction > 0) {
        this.marker = this.svgTop.append('circle');
        const startPointUp = this.pathStartPointUP(this.lineUpstring);
        this.marker.attr('r', 3)
          .attr('transform', 'translate(' + startPointUp + ')')
          .attr('fill', '#287aab');
        this.transitionUp();
      }
    }, 500);


    this.injectionFlowAnimation = setInterval(() => {
      if (this.totalConsumption > 0) {
        this.marker = this.svgBottom.append('circle');
        const startPointDown = this.pathStartPointDown(this.lineDownstring);
        this.marker.attr('r', 3)
          .attr('transform', 'translate(' + startPointDown + ')')
          .attr('fill', '#fb6059');
        this.transitionDown();
      }
    }, 500);
  }

  stopAnimations() {
    if(this.consumptionFlowAnimation) {
      clearInterval(this.consumptionFlowAnimation);
    }

    if(this.injectionFlowAnimation) {
      clearInterval(this.injectionFlowAnimation);
    }

    this.svgTop.selectAll('circle').remove();
    this.svgBottom.selectAll('circle').remove();
  }

  pathStartPointUP(line) {
    const d = this.upPath.attr('d'),
      dsplitted = line.split('');
    return dsplitted[1].split(',');
  }

  pathStartPointDown(line) {
    const d = this.downPath.attr('d'),
      dsplitted = line.split('');
    return dsplitted[1].split(',');
  }

  transitionUp() {
    this.marker.transition()
      .duration(4000)
      .attrTween('transform', this.translateAlong(this.upPath.node()))
      .on('end', function () {
        d3.select(this).remove();
      });
  }

  transitionDown() {
    this.marker.transition()
      .duration(4000)
      .attrTween('transform', this.translateAlong(this.downPath.node()))
      .on('end', function () {
        d3.select(this).remove();
      });
  }

  translateAlong(path) {
    const l = path.getTotalLength();
    return function (i) {
      return function (t) {
        const p = path.getPointAtLength(t * l);
        return 'translate(' + p.x + ',' + p.y + ')';
      };
    };
  }

  ngOnDestroy(): void {
    this.stopAnimations();
  }
}




// WEBPACK FOOTER //
// ./src/app/entities/home/home-tab/home-flows-view/flows/microgeneration-flow/microgeneration-flow.component.ts